/**
 * Mixin for ListItems components in '@/components/dynamic-list-items'
 */

export default {
  props: {
    listItem: {
      type: Object,
      required: true,
      default: () => ({})
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    mixChangeListItemHandler (value, fieldName) {
      this.$emit('change', { value, fieldName })
    },
    mixUploadImageHandler (data, field, itemField = '', itemIndex) {
      if (!data) { return }
      if (!itemField) {
        this.mixChangeListItemHandler(data, field)
      } else {
        this.mixChangeListItemItemHandler(data, field, itemIndex, itemField)
      }
    },
    mixChangeListItemItemHandler (value, fieldName, itemIndex, itemField) {
      this.$emit('change-item', {
        value,
        fieldName,
        itemIndex,
        itemField
      })
    },
    mixAddListItemItemHandler (fieldName, items) {
      const ListItemItem = items[this.listItem._item]
      if (!ListItemItem) { return }
      const itemList = this.listItem.data[fieldName]
      this.mixChangeListItemHandler([...itemList, new ListItemItem()], fieldName)
    },
    mixRemoveListItemItemHandler (itemIndex, fieldName) {
      this.$emit('remove-item', { itemIndex, fieldName })
    }
  }
}
